export default "__VITE_ASSET__DIfMEM_h__"